import templateData from './getTemplateData';
import { WorldReady } from '@paypalcorp/worldready';

let worldReady;

const getLocale = () => {
  const { country = 'US', language = 'en' } = templateData;
  return `${language}-${country}`;
};

export const initializeWorldReady = () => {
  let worldReadyData = JSON.parse(
    document.getElementById('worldReady').textContent
  );
  WorldReady.load(worldReadyData);
  console.log('WorldReady has loaded!');

  const locale = getLocale();
  worldReady = new WorldReady(locale);
};

export const getWorldReady = () => {
  return worldReady;
};
